/**
 * src/services/api.js
 *
 * Capa de acceso a datos via fetch().
 * Los JSON viven en public/data/ → se sirven como /data/*.json.
 *
 * · En desarrollo: Vite sirve public/ en localhost:4321/data/...
 * · En producción: Hostinger sirve los archivos estáticos de dist/
 *   (Vite copia public/ a dist/ durante el build automáticamente)
 *
 * Para actualizar datos: edita public/data/*.json y sube los archivos
 * al servidor. No hace falta recompilar la app.
 */

const BASE = '/data'

/**
 * Fetch genérico con caché en memoria para esta sesión.
 * Evita múltiples peticiones al mismo JSON en la misma visita.
 */
const cache = new Map()

export async function fetchData(endpoint) {
    if (cache.has(endpoint)) return cache.get(endpoint)

    const res = await fetch(`${BASE}/${endpoint}`)
    if (!res.ok) throw new Error(`Error cargando ${endpoint}: ${res.status}`)

    const data = await res.json()
    cache.set(endpoint, data)
    return data
}

/** Limpia la caché (útil si en el futuro se implementa recarga manual) */
export function clearCache(endpoint) {
    if (endpoint) cache.delete(endpoint)
    else cache.clear()
}
